import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

/**
 * The browser's Supabase client.
 *
 * It carries the anon key, which is public and in the bundle. That is safe only
 * because row-level security is the actual gate: every query this client makes
 * is filtered by policy, and no query in this application ever passes a tenant
 * filter of its own (design.md F5, layer 3). If a query needed a `coach_id` in
 * its `where` clause to be correct, the policy would be wrong.
 */

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must both be set.\n' +
      'Run `pnpm exec supabase start` and copy the printed API URL and anon key\n' +
      'into .env.local. See README.md, "Local setup".',
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
